import dayjs from "dayjs";
import {DateTimeParser} from "./DateTimeParser";

export class DateTimeFormatter {
    static formatDate(date: Date | string | null | undefined): string | null {
        if (!date) {
            return null;
        }
        return dayjs(date).format("L");
    }

    static formatAsIsoDate(date: Date | string | null | undefined): string | null {
        if (!date) {
            return null;
        }
        return dayjs(date).format("YYYY-MM-DD");
    }

    static formatDateTime(dateTime: Date | string | null | undefined) {
        if (!dateTime) {
            return null;
        }
        return dayjs(dateTime).format("L LTS");
    }

    static formatAsIsoDateTime(dateTime: Date | string | null | undefined) {
        if (!dateTime) {
            return null;
        }
        return dayjs(dateTime).toISOString();
    }

    static formatTime(time: Date | string | null | undefined) {
        if (!time) {
            return null;
        }
        let dayjsTime;
        if (typeof time === "string") {
            dayjsTime = DateTimeParser.parseTime(time);
        } else {
            dayjsTime = dayjs(time);
        }
        return dayjsTime.format("LTS");
    }
}